import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import LoginHeader from '../../../Login_header';
import Menu from '../../../Menu';
import * as Picklist from '../../../Picklist';
import * as Common from './../../../Common';
import Dialog from './../../../Dialog';

const Rep_vtm_in_out = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const branchDisable = sessionStorage.getItem('branchDisable');
    const HOCODE = sessionStorage.getItem('hocode');
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');
    const [generateType, setGenerateType] = useState("V");
    const [filterLocationType, setFilterLocationType] = useState("O");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [issuer, setIssuer] = useState(null);
    const [groupCode, setGroupCode] = useState(0);
    const [accountCode, setAccountCode] = useState(0);
    const [filterIssuerType, setFilterIssuerType] = useState("A");


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_VTM_IN_OUT'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }

    const handleLocationType = (e) => {
        setIssuer(null);
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }
    const handleIssuerChange = (value) => {
        console.log(value);
        setIssuer(value);
        const iss = value.id.split('^');
        setGroupCode(iss[1]);
        setAccountCode(iss[2]);
    }
    const handleGenerate = () => {
        $(".loader").show();

        if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        } else if (fromDate > toDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        if (filterIssuerType === 'O' && issuer == null) {
            setMsgText("Select Issuer.");
            setMsgBox(true);
            $(".loader").hide();
        } else {
            const obj = {
                fromDate: Common.dateYMD(fromDate),
                fromDateDMY: Common.dateDMY(fromDate),
                toDate: Common.dateYMD(toDate),
                toDateDMY: Common.dateDMY(toDate),
                locationCode: locationCode,
                filterLocationType: filterLocationType,
                locationType: filterLocationType,
                generateType: generateType,
                groupCode: groupCode,
                accountCode: accountCode,
                filterIssuerType: filterIssuerType,
                showHeader: true
            };
            if (generateType === 'D') {
                Common.callDownloadApiPost1(Common.apiRepvtminout, "post", [sid, 'download', JSON.stringify(obj)], (result) => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apiRepvtminout, [sid, 'view', JSON.stringify(obj)], (result) => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });
            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h4>VTM In Out Report</h4>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterLocationType} onChange={handleLocationType}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterLocationType === 'O' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={filterLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleChangeLocation}
                                    isDisabled={branchDisable === "true"}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col></> : null}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label> From Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label> To Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Issuer All/One<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterIssuerType} onChange={e => setFilterIssuerType(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterIssuerType === 'O' ?
                        <>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Issuer<span className="text-danger">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={issuer}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', filterLocationType === 'A' ? HOCODE : locationCode)}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleIssuerChange}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                        </> : null}
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_vtm_in_out;
